// Work on the address around the caret, preserving the rest of the To line.
export function recipientToken(value: string, caret: number) {
  let quoted = false;
  let angled = false;
  let start = 0;
  let end = value.length;
  for (let i = 0; i < value.length; i++) {
    const char = value[i];
    if (char === '\\') { i++; continue; }
    if (char === '"') quoted = !quoted;
    if (!quoted && char === '<') angled = true;
    if (!quoted && char === '>') angled = false;
    if (!quoted && !angled && (char === ',' || char === ';')) {
      if (i < caret) start = i + 1;
      else { end = i; break; }
    }
  }
  return { start, end, query: value.slice(start, end).trim() };
}

export function insertRecipient(value: string, caret: number, email: string) {
  const { start, end } = recipientToken(value, caret);
  const prefix = value.slice(0, start);
  const replacement = (start ? ' ' : '') + email;
  const suffix = value.slice(end);
  return { value: prefix + replacement + suffix, caret: prefix.length + replacement.length };
}

// A space finishes a complete email, but stays inside an unfinished person's name.
// Keep canonical commas in state so existing draft/send payloads retain every recipient.
export function normalizeRecipientInput(value: string, caret: number) {
  let result = '';
  let start = 0;
  let quoted = false;
  let angled = false;
  let offset = 0;
  for (let i = 0; i < value.length; i++) {
    const char = value[i];
    if (char === '\\') {
      result += char + (value[i + 1] || '');
      i++;
      continue;
    }
    if (char === '"') quoted = !quoted;
    if (!quoted && char === '<') angled = true;
    if (!quoted && char === '>') angled = false;
    if (!quoted && !angled && (char === ',' || char === ';')) {
      result += ',';
      start = result.length;
      continue;
    }
    if (!quoted && !angled && /\s/.test(char)) {
      const preceding = result.slice(start).trim();
      if (/^[^\s<>@,;]+@[^\s<>@,;]+\.[^\s<>@,;]+$/.test(preceding)) {
        result += ',';
        start = result.length;
        if (i < caret) offset++;
      }
    }
    result += char;
  }
  return { value: result, caret: caret + offset };
}
